import React from "react";
// eslint-disable-next-line no-restricted-imports -- TODO: update to `next/navigation` before using this component in App Router
import { useRouter } from "next/router";

import { useShopItemAd } from "@/hooks/useShopItemAd";
import pageFromQuery from "@/utils/pageFromQuery";
import { leaflyShopStringify } from "@/utils/qs";

import ItemCount from "@/components/ItemCount/ItemCount";
import PageNavigation from "@/components/PageNavigationV2";
import ShopItemAd from "@/components/ShopItemAd";
import ShopItemCard from "@/components/ShopItemCard";
import { ShopItem } from "@/components/ShopItemCard/types";
import Sort from "@/components/UnifiedShop/Sort";
import { UNIFIED_SHOP_PAGE_SIZE } from "@/components/UnifiedShop/UnifiedShop";
import styles from "@/components/ShopItemAd/ShopItemAd.module.css";

type ShopItemResultsProps = {
  shopAdsFlagEnabled?: boolean;
  shopItems: ShopItem[];
  totalCount: number;
};

const BACKEND_PAGINATION_LIMIT = 10000;

const ShopItemResults: React.FC<ShopItemResultsProps> = ({
  shopAdsFlagEnabled = false,
  shopItems,
  totalCount,
}) => {
  const {
    query: { page },
  } = useRouter();
  const currentPage = pageFromQuery(page);

  const { showShopItemAd, targeting } = useShopItemAd();

  return (
    <div>
      <div className="flex justify-between">
        <ItemCount itemCount={totalCount} />
        {!!shopItems?.length && <Sort />}
      </div>
      <hr className="border-light-grey md:hidden mb-md mt-sm -mx-lg" />
      <div
        className={`flex flex-col gap-md ${styles["shop-result-container"]}`}
      >
        {shopItems.length &&
          shopItems.map((shopItem, idx) => (
            <React.Fragment key={idx}>
              {shopAdsFlagEnabled &&
                showShopItemAd() &&
                [0, 4, 8, 12].includes(idx) && (
                  <ShopItemAd
                    slot={[0, 4, 8, 12].indexOf(idx) + 1}
                    targeting={targeting()}
                  />
                )}
              <ShopItemCard shopItem={shopItem} />
            </React.Fragment>
          ))}
      </div>
      <PageNavigation
        className="my-xxl"
        currentPage={currentPage}
        stringifyMethod={leaflyShopStringify}
        totalPages={
          totalCount > BACKEND_PAGINATION_LIMIT
            ? Math.ceil(BACKEND_PAGINATION_LIMIT / UNIFIED_SHOP_PAGE_SIZE) - 1
            : Math.ceil(totalCount / UNIFIED_SHOP_PAGE_SIZE)
        }
      />
    </div>
  );
};

export default ShopItemResults;
